import { render, staticRenderFns } from "./VFD_Displays.vue?vue&type=template&id=87e4af94&"
import script from "./VFD_Displays.vue?vue&type=script&lang=js&"
export * from "./VFD_Displays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports